import { Navigate, Outlet, useOutletContext } from "react-router";
import type { AppOutletContext } from "@/src/layouts/AppLayout";

export default function RequireMonitoring() {
  const ctx = useOutletContext<AppOutletContext | null>();
  if (ctx && !ctx.enableMonitoring) return <Navigate to="/dashboard" replace />;
  return <Outlet context={ctx} />;
}
